import React from "react";
import {Button, Checkbox} from "biggerui";
import {TARGET_OPTIONS} from "hooks/featureFlags";
import {useAuth} from "hooks/useAuth";
import {mayChangeFlagTarget} from "data/permissions";
import "./index.css";

export const FeatureCard = ({feature, onDelete, onUpdate}) => {
  const {role: callerRole} = useAuth();
  return (
    <div className="admin-comp-feature-item">
      <div className="admin-comp-feature-header">
        <div className="admin-comp-feature-header-main">
          <h3 className="admin-comp-feature-name">{feature.name || feature.key}</h3>
          <span className="admin-comp-feature-key">{feature.key}</span>
        </div>
        <div className="admin-comp-feature-header-side">
          <Button
            variant="destructive"
            className="admin-comp-delete-button"
            onClick={() => onDelete(feature)}
          >
            Delete
          </Button>
        </div>
      </div>

      <div className="admin-comp-feature-details">
        {feature.description && (
          <p className="admin-comp-feature-description">{feature.description}</p>
        )}

        <div className="admin-comp-meta-row">
          <div className="admin-comp-meta-item">
            <span className="admin-comp-meta-label">Created</span>
            <span className="admin-comp-meta-value">
              {new Date(feature.createdAt).toLocaleString()}
            </span>
          </div>
          <div className="admin-comp-meta-item">
            <span className="admin-comp-meta-label">Updated</span>
            <span className="admin-comp-meta-value">
              {new Date(feature.updatedAt).toLocaleString()}
            </span>
          </div>
        </div>

        <div className="admin-comp-feature-targets">
          <h4 className="admin-comp-targets-title">Targets</h4>
          <div className="admin-comp-targets-list">
            {TARGET_OPTIONS.map((target) => {
              const enabled = !!(feature.targets && feature.targets[target.key]);
              return (
                <div key={target.key} className="admin-comp-target-row">
                  <Checkbox
                    checked={enabled}
                    disabled={!mayChangeFlagTarget(callerRole, target.key)}
                    onChange={(checked) =>
                      onUpdate.mutate({
                        role: target.key,
                        key: feature.key,
                        enabled: checked,
                      })
                    }
                    label={target.label}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
